import { z } from 'zod'

export const paramsSchema = z.object({
  facets: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
